
class BillboardDetailMenu{
    constructor(){
        this.main = document.getElementById('billboard_detail_menu');

        this._btns = Array.from(this.main.querySelectorAll('a'));

        this._currentBtn = null;

        this._btns.forEach((btn)=>{
            btn.addEventListener('click', this._onClickBtn.bind(this));
        })

    }

    set(index){
        if(this._currentBtn != null){
            this._currentBtn.parentElement.classList.remove('nav-tab__item--active');
        }

        if(typeof this._btns[index] != 'undefined'){
            this._currentBtn = this._btns[index];
            this._currentBtn.parentElement.classList.add('nav-tab__item--active');
        }
    }

    addEventListener(event, callback){
        this.main.addEventListener(event, callback);
    }

    _onClickBtn(e){
        e.preventDefault();

        let index = this._btns.indexOf(e.currentTarget);

        this.main.dispatchEvent(new CustomEvent('clickBtn', {detail:{index: index}}));
    }

}

export default BillboardDetailMenu;